import { render, staticRenderFns } from "./CreateUpload.vue?vue&type=template&id=6dd7920b"
import script from "./CreateUpload.vue?vue&type=script&lang=js"
export * from "./CreateUpload.vue?vue&type=script&lang=js"
import style0 from "./CreateUpload.vue?vue&type=style&index=0&id=6dd7920b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports